import { GetApp } from '@material-ui/icons';
import { Modal, ModalContent } from '../../../components/Modal';
import { CsvImportColumn } from '../../../lib/csv';
import { CSVImport } from '../../../components/CSVImport';

type Props<T> = {
  canOverwrite: boolean;
  hideOverwriteMessage?: boolean;
  settingName: string;
  requiredColumns: CsvImportColumn[];
  onClose(): void;
  onImport(csv: Array<T>, overwrite: boolean): void;
  open: boolean;
};

export function CSVImportModal<T>(props: Props<T>) {
  return (
    <Modal
      icon={<GetApp />}
      header={`${props.settingName} Import`}
      open={props.open}
      onClose={props.onClose}
      maxWidth="md"
    >
      <ModalContent className="flex flex-col items-center justify-center">
        <CSVImport<T> {...props} />
      </ModalContent>
    </Modal>
  );
}
